import { useGetQuery, usePostMutation } from "slices/api";
import {
  FIRE_SAFETY,
  FIRE_SAFETY_APPLICATION,
  REGISTER_BUILDING,
} from "tagTypes";

export const useGetApplicantStatusQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/building-information-status",
    query,
    tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
  });

export const usePostLoginUserMutation = () => {
  const [loginUser, data] = usePostMutation();
  const login = async (payload, query = {}) => {
    return await loginUser({
      endpoint: "/firesafety-user/login",
      query,
      payload: payload || {},
      tags: [FIRE_SAFETY],
    }).unwrap();
  };
  return [login, data];
};

export const usePostRegisterConsumerMutation = () => {
  const [registerUser, data] = usePostMutation();
  const register = async (payload, query = {}) => {
    return await registerUser({
      endpoint: "/firesafety-user/register-consumer",
      query,
      payload: payload || {},
      toastMessage: "Registered successfully",
      tags: [FIRE_SAFETY],
    }).unwrap();
  };
  return [register, data];
};

export const usePostRegisterUserMutation = () => {
  const [loginUser, data] = usePostMutation();
  const login = async (payload, query = {}) => {
    return await loginUser({
      endpoint: "/firesafety-user/register-user",
      query,
      payload: payload || {},
      toastMessage: "Registered successfully",
      tags: [FIRE_SAFETY],
    }).unwrap();
  };
  return [login, data];
};

export const usePostRequestFireSafetyOTPMutation = () => {
  const [handleForgotPassword, data] = usePostMutation();
  const forgotPassword = async (query = {}, toastMessage) => {
    return await handleForgotPassword({
      endpoint: "/firesafety-user/request-otp",
      query,
      toastMessage,
      tags: [],
    }).unwrap();
  };
  return [forgotPassword, data];
};
